<!--

 -->

<template>
  <div class="oxd-table-card-cell">
    <div v-show="showHeader" class="header">
      {{ header.title }}
    </div>
    <div class="data">
      <oxd-text tag="p">
        {{ reviewPeriodStart }} -
        <oxd-text tag="span" class="time">
          {{ reviewPeriodEnd }}
        </oxd-text>
      </oxd-text>
    </div>
  </div>
</template>

<script>
import {useInjectTableProps} from '@ohrm/oxd';

export default {
  name: 'ReviewPeriodCell',

  props: {
    header: {
      type: Object,
      required: true,
    },
    reviewPeriodStart: {
      type: String,
      required: true,
    },
    reviewPeriodEnd: {
      type: String,
      required: true,
    },
  },

  setup() {
    const {screenState} = useInjectTableProps();

    return {
      screenState,
    };
  },

  computed: {
    showHeader() {
      return !(
        this.screenState.screenType === 'lg' ||
        this.screenState.screenType === 'xl'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.oxd-table-card-cell {
  display: block;
  & .header {
    font-weight: 700;
  }
  & .time {
    white-space: nowrap;
  }
}
</style>
